<section class="header">  
  <edge-global-header></edge-global-header>
</section>
    
<edge-article [newsArticle]="newsArticle$ | async"></edge-article>

<section class="footer">
  <edge-global-footer></edge-global-footer>
</section>